import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=3dca07b8"
import script from "./UiTabs.vue?vue&type=script&lang=js"
export * from "./UiTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports